<!--  -->
<template>
  <div class="header" >
      <slot name='logo'></slot>
      <User />
  </div>
</template>

<script>
import User from '@/components/User'

export default {
  name: "Header",

  data () {
    return {
      status: true
    };
  },
  methods:{
    goBack(){
      this.$router.push({
        path:'/'
      })
    },
  },
  components: {
    User,
  },
}

</script>
<style lang='less' scoped>
@IMG_URL: "~@/assets";
@import "~@/assets/less/mixin";

.header{
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 16px;
  box-sizing: border-box;
  position: absolute;
  top:0;
  left:0;
  .logo{
    display: flex;
    cursor: pointer;
    .logo_pic{
      width: 110px;
      height: auto;
    }
    .logo_line{
      width:2px;
      height:16px;
      background:rgba(255,255,255,1);
      border-radius:2px;
      margin: 4px 8px 0;
    }
    .logo_title{
      font-size:18px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height: 23px;
    }
  }
}

</style>